import React, { useEffect } from "react";

/** Lightweight SEO head — sets title, meta, OG, Twitter, JSON-LD. */
export const SEOHead = ({
  title = "AuditIQ — Government Budget Transparency & Cybersecurity Platform",
  description = "AuditIQ is a GovTech accountability platform for municipal infrastructure oversight, AI-powered budget analysis, and critical-infrastructure cybersecurity via the CyberWater Security Layer.",
  path = "/",
  image = "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=1200&q=80",
  schema = null,
}) => {
  useEffect(() => {
    const set = (sel, attr, val) => {
      let el = document.head.querySelector(sel);
      if (!el) {
        el = document.createElement("meta");
        const m = sel.match(/\[(.+)="(.+)"\]/);
        if (m) el.setAttribute(m[1], m[2]);
        document.head.appendChild(el);
      }
      el.setAttribute(attr, val);
    };
    document.title = title;
    set('meta[name="description"]', "content", description);
    set('meta[property="og:title"]', "content", title);
    set('meta[property="og:description"]', "content", description);
    set('meta[property="og:image"]', "content", image);
    set('meta[property="og:type"]', "content", "website");
    set('meta[property="og:url"]', "content", window.location.origin + path);
    set('meta[name="twitter:card"]', "content", "summary_large_image");
    set('meta[name="twitter:title"]', "content", title);
    set('meta[name="twitter:description"]', "content", description);
    set('meta[name="twitter:image"]', "content", image);
    set('meta[name="theme-color"]', "content", "#0D1F3C");

    let ld = document.getElementById("auditiq-ld");
    if (!ld) { ld = document.createElement("script"); ld.type = "application/ld+json"; ld.id = "auditiq-ld"; document.head.appendChild(ld); }
    const data = schema || {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      name: "AuditIQ",
      applicationCategory: "GovernmentApplication",
      description,
      operatingSystem: "Web",
      offers: { "@type": "Offer", price: "0", priceCurrency: "USD" },
      publisher: { "@type": "Organization", name: "AuditIQ" },
    };
    ld.textContent = JSON.stringify(data);
  }, [title, description, path, image, schema]);
  return null;
};

export default SEOHead;
